import { motion } from "framer-motion";

const TRUST_ITEMS = [
  ["Driver Matching", "Qualifications + availability"],
  ["Secured Payments", "Clear funding status"],
  ["Documented Handoffs", "Custody + condition records"],
];

export const HeroTrustBar = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ delay: 1.1, duration: 0.7 }}
    className="mt-14 grid grid-cols-3 gap-6 max-w-lg border-t border-white/15 pt-6"
  >
    {TRUST_ITEMS.map(([t, s]) => (
      <div key={t}>
        <div className="text-white font-bold text-sm">{t}</div>
        <div className="text-white/50 text-xs mt-1">{s}</div>
      </div>
    ))}
  </motion.div>
);
